import { gradeToPhase } from '@suntex.fim/assessment'

export { handleKeyboardClick, handleEnterOrSpacePress } from '@suntex.fim/ui'

export const openVideo = (
  mediaId: string | undefined,
  friendlyName: string | undefined
): void => {
  if (mediaId && friendlyName) {
    const videoUrl = `${window.location.origin}/video?mediaId=${mediaId}&friendlyname=${encodeURIComponent(friendlyName)}`
    window.open(videoUrl)
  }
}
export const redirectToLink = (url: string): void => {
  window.open(url, '_blank', 'noopener,noreferrer')
}

export const getInitials = (displayName: string): string => {
  // Input validation
  if (!displayName || typeof displayName !== 'string') {
    return ''
  }

  // List of common prefixes/honorifics to exclude
  const excludedWords = new Set(['mr', 'mrs', 'ms', 'dr'])

  // Clean and process the name
  const cleanedName = displayName
    .trim()
    .replace(/[.,]/g, '') // Remove periods and commas
    .replace(/\s+/g, ' ') // Normalize multiple spaces to single space

  // Split into words and filter out excluded words and empty strings
  const validWords = cleanedName.split(' ').filter((word) => {
    const cleanWord = word.toLowerCase().trim()
    return cleanWord.length > 0 && !excludedWords.has(cleanWord)
  })

  // If no valid words remain, fallback to first two characters of original name
  if (validWords.length === 0) {
    const fallbackName = displayName.replace(/[^a-zA-Z]/g, '')
    return fallbackName.slice(0, 2).toUpperCase()
  }

  // Generate initials from valid words (max 2)
  const initials = validWords
    .slice(0, 2) // Take only first 2 valid words
    .map((word) => word[0].toUpperCase())
    .join('')

  return initials
}

export { gradeToPhase }

export enum ActivityMode {
  Day = 1,
  Week = 2,
  Month = 3
}
